import * as Sentry from '@sentry/react';
export const captureAxiosError = (error) => {
    const { config } = error;
    Sentry.withScope((scope) => {
        scope.setTag('method', config.method);
        scope.setTag('request_url', config.url);
        scope.setTag('error_code', error.status);
        scope.setExtras(JSON.stringify(config.data));
        return Sentry.captureException(new Error(`${error.message} - ${error.response.data.message}`));
    });
};
